export const LOAD_INCENTIVE_PROGRAM_STATUS = 'LOAD_INCENTIVE_PROGRAM_STATUS';
export const LOAD_INCENTIVE_PROGRAM_STATUS_SUCCESS =
  'LOAD_INCENTIVE_PROGRAM_STATUS_SUCCESS';
export const LOAD_INCENTIVE_PROGRAM_STATUS_FAILED =
  'LOAD_INCENTIVE_PROGRAM_STATUS_FAILED';
